import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db, hasFirebaseConfig } from "../firebase";

export function useFirestoreDoc(path, id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hasFirebaseConfig || !db || !id) {
      setLoading(false);
      if (!id) setData(null);
      else setError(new Error("missing-config"));
      return;
    }
    setLoading(true);
    const ref = doc(db, path, id);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) setData({ id: snap.id, ...snap.data() });
        else setData(null);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error(`doc(${path}/${id}) error`, err);
        setError(err);
        setLoading(false);
      }
    );
    return () => unsub();
  }, [path, id]);

  return { data, loading, error };
}
